module.exports = __webpack_public_path__ + "img/4.88ff4e9c.jpg";